/**
 * Gateway date-clarification chips (DATE_RANGE_SUGGESTED_ACTIONS) must not be
 * re-sent as standalone chat prompts — that drops person/question context.
 * Map them to panel date apply + pending resend, or open the date picker.
 */

export type CopilotDateClarificationPreset = 'today' | 'last_week' | 'this_month';

export interface CopilotDateClarificationChip {
  label: string;
  type: 'apply_date_preset';
  preset: CopilotDateClarificationPreset;
}

/** True when the chip opens the scope drawer for a custom date. */
export function isDateClarificationPickerChip(raw: string): boolean {
  return /^a specific date\b/i.test((raw ?? '').trim());
}

/**
 * Map a gateway date-clarification suggestion to a panel action.
 * Returns null when the string is not a known date chip.
 */
export function mapDateClarificationChip(
  raw: string,
): CopilotDateClarificationChip | { label: string, type: 'open_scope' } | null {
  const label = (raw ?? '').trim();
  if (!label) {
    return null;
  }
  if (isDateClarificationPickerChip(label)) {
    return { label, type: 'open_scope' };
  }
  if (/^today$/i.test(label)) {
    return { label, type: 'apply_date_preset', preset: 'today' };
  }
  if (/^last week$/i.test(label)) {
    return { label, type: 'apply_date_preset', preset: 'last_week' };
  }
  if (/^this month$/i.test(label)) {
    return { label, type: 'apply_date_preset', preset: 'this_month' };
  }
  return null;
}
